<template>
  <div>
    <div class="basic-info">
      <el-form
        label-position="left"
        label-width="7rem"
        ref="AdsForm"
        :model="adsInfo"
      >
        <div class="basic-item" v-if="isEdit">
          <div class="basic-item-title">基本信息</div>
          <div class="basic-item-main">
            <div class="main-item">
              <el-form-item label="广告名称">
                <el-input
                  v-model="adsInfo.name"
                  placeholder="请输入广告名称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="关联楼盘">
                <el-select
                  v-model="adsInfo.estateName"
                  filterable
                  reserve-keyword
                  clearable
                  @change="selectEstate"
                  remote
                  :remote-method="getPublicEstates"
                  @visible-change="clearEstates"
                  placeholder="请选择楼盘"
                >
                  <el-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="index"
                    :label="item.name"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="广告排序">
                <el-select
                  v-model="adsInfo.sort"
                  filterable
                  reserve-keyword
                  clearable
                  placeholder="请选择广告排序"
                >
                  <el-option
                    v-for="index in 10"
                    :key="index"
                    :value="index"
                    :label="index"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="投放时间">
                <el-date-picker
                  class="date-picker"
                  v-model="launchTime"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="广告介绍" class="auto-height">
                <el-input
                  v-model="adsInfo.stock"
                  placeholder="请输入广告介绍"
                  type="textarea"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                  clearable
                ></el-input>
              </el-form-item>
              <div class="group-btn">
                <el-button
                  type="primary"
                  @click="updateAds"
                  :loading="submitLoading"
                  >{{ submitText }}</el-button
                >
                <el-button @click="editAds">取消</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="basic-item" v-else>
          <div class="basic-item-title">
            基本信息<span class="title-btn" @click="editAds">管理</span>
          </div>
          <div class="basic-item-main">
            <div class="main-item">
              <el-form-item label="广告名称">
                {{ adsInfo.name | nullValue }}
              </el-form-item>
              <el-form-item label="关联楼盘">
                {{ adsInfo.estateName | nullValue }}
              </el-form-item>
              <el-form-item label="广告排序">
                {{ adsInfo.sort | nullValue }}
              </el-form-item>

              <el-form-item label="投放时间">
                {{ adsInfo.startTime | nullValue }}
                <span class="time-placehoder">-</span>
                {{ adsInfo.endTime | nullValue }}
              </el-form-item>
              <el-form-item label="广告介绍" class="auto-height">
                {{ adsInfo.more | nullValue }}
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getAdsInfo, updateAdsInfo } from "@/http/api/ads";

import { getPublicEstates } from "@/http/api/estate";
import { deepCopy } from "@/utils/deepCopy";
import { getAdsSettings, getInformationSettings } from "@/http/api/system";
import { dateFormat } from "@/common/filters";
import headerTop from "@/components/HeaderTop";
import basic from "./basic";
export default {
  data() {
    return {
      id: this.$route.params.id,
      // headerText: "管理广告",
      submitLoading: false,
      isEdit: false,
      fileList: [],
      submitText: "保存",
      uploadText: "上传图片",
      positionIndex: 0, // 选定的展位下标
      launchTime: [],
      estateList: [],
      adsInfo: {
        name: "",
        estateId: "",
        estateName: "",
        startTime: null,
        endTime: null,
        sort: 0,
        more: "",
      }, // 广告对象
    };
  },
  mounted() {
    this.init();
    this.getAdsSetting();
    this.getPublicEstates();
  },
  methods: {
    editAds() {
      this.isEdit = !this.isEdit;
    },

    //获取楼盘
    getPublicEstates(v) {
      let query = {
        maxResultCount: 20,
        filter: "",
        condition: "name",
      };
      if (v) {
        query.filter = v;
      }
      getPublicEstates(query).then((res) => {
        this.estateList = res.result.items;
      });
    },
    clearEstates(v) {
      if (!v) {
        this.estateList = [];
      }
    },
    selectEstate(val) {
      if (val || val === 0) {
        this.adsInfo.estateId = this.estateList[val].id;
        this.adsInfo.estateName = this.estateList[val].name;
      } else {
        this.adsInfo.estateId = "00000000-0000-0000-0000-000000000000";
        this.adsInfo.estateName = "";
      }
    },
    init() {
      getAdsInfo(this.id).then((res) => {
        this.adsInfo.name = res.result.name;
        this.adsInfo.startTime = res.result.startTime;
        this.adsInfo.endTime = res.result.endTime;
        this.adsInfo.estateId = res.result.estateId;
        this.adsInfo.estateName = res.result.estateName;
        this.adsInfo.sort = res.result.sort;
        this.adsInfo.more = res.result.more;
        if (res.result.startTime && res.result.endTime) {
          this.launchTime = [res.result.startTime, res.result.endTime];
        }
      });
    },

    // 管理广告
    updateAds() {
      this.$refs.AdsForm.validate((valid) => {
        if (valid) {
          if (this.launchTime.length > 0) {
            this.adsInfo.startTime = dateFormat(this.launchTime[0]);
            this.adsInfo.endTime = dateFormat(this.launchTime[1]);
          } else {
            this.adsInfo.startTime = null;
            this.adsInfo.endTime = null;
          }
          let adsInfo = deepCopy(this.adsInfo);

          this.submitLoading = true;
          this.submitText = "保存中";
          //   var formData = new FormData();
          //   formData.append("Advert", JSON.stringify(adsInfo));
          //   if (JSON.stringify(this.photoFile) != "{}") {
          //     formData.append("File", this.photoFile);
          //   }
          updateAdsInfo(this.id, adsInfo)
            .then((res) => {
              if (res && res.result) {
                this.$message.success({
                  message: "修改成功",
                  showClose: true,
                });
                this.submitLoading = false;
                this.submitText = "保存";
                this.$router.go(-1);
              } else {
                this.submitLoading = false;
                this.submitText = "保存";
              }
            })
            .catch((err) => {
              this.submitLoading = false;
              this.submitText = "保存";
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.update-ads {
  overflow-y: scroll;
  .basic-info {
    margin: 20px;
    padding: 20px;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    min-width: 960px;
    text-align: left;
    background-color: #fff;

    .basic-item {
      .post-symbol {
        color: #f56c6c;
      }
      .basic-item-title {
        @include flex(row, center);
        justify-content: space-between;
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
        .title-btn {
          font-weight: 500;
          cursor: pointer;
          color: $--color-primary;
        }
      }
      .time-placehoder {
        padding: 0 5px;
      }

      .basic-item-main {
        display: flex;

        .main-item {
          ::v-deep .date-picker {
            width: 330px;
            .el-input__inner {
              width: 100%;
            }
            .el-icon-date {
              left: 10px;
            }
            .el-icon-circle-close {
              position: absolute;
              right: 0;
            }
          }
          .el-select,
          .el-input {
            width: 330px;
          }
          ::v-deep .el-date-editor {
            .el-input__inner {
              padding-left: 30px !important;
            }
            .el-icon-circle-close {
              right: 0;
            }
          }

          ::v-deep .el-form-item__content {
            .el-input-group {
              vertical-align: baseline;
            }
          }
        }
      }
    }

    .group-btn {
      margin-top: 5px;
      margin-left: 7rem;
    }
  }
}
</style>